import { RouteRecordRaw } from 'vue-router';

const incomeGoalRoutes: Array<RouteRecordRaw> = [
  {
    path: 'income-goal',
    component: () =>
      import('@/app/income-goal/components/income-goal-index-component.vue'),
    name: 'app.income-goal',
  },
];

export default incomeGoalRoutes;
